import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ENUM_PropertyInvestmentType } from '@api-new/common';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { paths } from '@platform/paths';
import { AddSmartSearchDialogStep } from '@platform/smart-search/enums/add-smart-search-dialog-step.enum';
import { SmartSearchType } from '@platform/smart-search/enums/smart-search-type.enum';
import { AddSmartSearchDialogComponent } from '@platform/smart-search/pages/add-smart-search-dialog/add-smart-search-dialog.component';
import { addSmartSearchSuccess } from '@shared/store/smart-searches/smart-searches.actions';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Injectable()
export class AddNewPortfolioItemStore extends ComponentStore<object> {
  private readonly router = inject(Router);
  private readonly dialogService = inject(DialogService);
  private readonly globalStore = inject(Store);

  constructor() {
    super({});
  }

  // ACTIONS -----------------------------------------------------------------------------------------------------------

  readonly openAddSmartSearchDialog = this.effect((openAddSmartSearchDialog$: Observable<void>) =>
    openAddSmartSearchDialog$.pipe(
      tap(() => {
        const smartSearchFormDialogRef = this.dialogService.open(AddSmartSearchDialogComponent, {
          closable: false,
          closeOnEscape: true,
          transitionOptions: '0ms',
          data: {
            predefinedSmartSearch: {
              addSmartSearchDialogFormRawValues: { typeSelection: { type: SmartSearchType.NEW_PROPERTY_MAXIMUM_PRICE } },
              dialogStep: AddSmartSearchDialogStep.NEW_PROPERTY_INVESTMENT_TYPE_SELECTION,
            },
          },
        });
        smartSearchFormDialogRef.onClose.pipe(take(1)).subscribe((smartSearch) => {
          if (smartSearch) {
            void this.router.navigate([paths.PLATFORM, paths.platform.SMART_SEARCH, smartSearch.id]);
            this.globalStore.dispatch(addSmartSearchSuccess({ smartSearch }));
          }
        });
      }),
    ),
  );

  readonly redirectToAddProperty = (investmentType: ENUM_PropertyInvestmentType): void => {
    this.router.navigate(['/' + paths.PLATFORM, paths.platform.PROPERTY, paths.platform.property.ADD], { queryParams: { investmentType } });
  };
}
